/**
 * I passi del tutorial guidato di Incoming/Outcoming > Cassa.
 *
 * Nessun preparativo: il menu del piu' ha una voce sola e il passo la racconta
 * senza doverlo aprire, quindi non serve un `onStop` che richiuda niente.
 *
 * Il carrello e la tabella delle candidate stanno dietro un `v-if` sui dati: a
 * carrello vuoto quei passi si agganciano in basso e raccontano lo stesso cosa
 * ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-cashout"] [data-tour="${name}"]`;

export function createWarehouseCashoutTourSteps() {
	return [
		{
			body: "Questa e' la cassa del negozio: si scansiona quello che il cliente porta via, si chiude, e il sistema registra un ordine vero e proprio con canale di vendita 'Cassa'. Non e' uno scarico di magazzino come le altre voci di questo menu - e' una vendita, che finisce nell'elenco ordini insieme a quelle dei marketplace e del sito.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Vendere al banco',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Ogni lettura riuscita mette l'articolo nel carrello. Se il codice non e' su nessun prodotto compare un avviso rosso e non viene aggiunto niente.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Battere un prodotto',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. Il codice inviato fa esattamente quello che fa la pistola: mette l'articolo nel carrello.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Quando lo stesso codice sta su piu' varianti il sistema non sceglie per te: compaiono tutte le candidate con brand, nome, caratteristiche, sku ed ean, e nel carrello entra solo quella su cui premi CONFERMA.",
			key: 'candidates',
			placement: 'top',
			target: at('candidates'),
			timeout: 250,
			title: "Quando il codice e' ambiguo",
		},
		{
			body: "Il carrello in corso: una riga per articolo con foto, nome, sku, caratteristiche, prezzo, quantita' e parziale. La quantita' si cambia direttamente nel campo - il parziale e il totale si rifanno mentre scrivi - e il pulsante rosso ELIMINA toglie quella riga sola dallo scontrino.",
			key: 'cart',
			placement: 'bottom',
			/*
			 * L'intestazione, non la tabella intera: con molti articoli il carrello
			 * supera l'altezza dello schermo e il ritaglio coprirebbe tutto il
			 * visibile, facendo sembrare sparito il velo.
			 */
			target: `${at('cart')} thead`,
			timeout: 250,
			title: 'Il carrello',
		},
		{
			body: "Il prezzo totale si somma da solo dai parziali e non si puo' scrivere a mano: se serve cambiare quanto paga il cliente si agisce sulle quantita' o si toglie una riga. Uno sconto libero, da qui, non si fa.",
			key: 'total',
			placement: 'top',
			target: at('total'),
			timeout: 250,
			title: 'Il totale',
		},
		{
			body: "ANNULLA svuota il carrello e lascia tutto com'era: nessun ordine, nessuna giacenza toccata. Si usa quando il cliente cambia idea al banco.",
			key: 'cancel',
			placement: 'top',
			target: at('cancel'),
			timeout: 250,
			title: 'Annullare la vendita',
		},
		{
			body: "CONCLUDI chiude la vendita: viene creato un ordine con un suo numero, canale e metodo di pagamento 'Cassa', e da quel momento vive come tutti gli altri ordini - lo ritrovi nell'elenco ordini, nelle statistiche e nei documenti. Da qui in poi le correzioni si fanno sull'ordine, non piu' su questa pagina.",
			key: 'checkout',
			placement: 'top',
			target: at('checkout'),
			timeout: 250,
			title: 'Chiudere la vendita',
		},
		{
			body: "Il piu' in alto apre una voce sola, Aggiungi prodotto, per mettere nel carrello un articolo che non riesci a scansionare - codice rovinato, etichetta staccata, prodotto senza barcode.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere a mano',
		},
	];
}
